import BaseService from '../base'

class resourcesService extends BaseService {
    // 查询组件列表
    async resourcesList(postData) {
        return await this.get('/api/v2/admin//wechatComponents', postData);
    }
    // 删除组件
    async deleteResources(id) {
        return await this.delete(`/api/v2/admin//wechatComponents/${id}`);
    }
    // 查询组件详情
    async getResources(id) {
        return await this.get(`/api/v2/admin/wechatComponents/${id}`);
    }
    // 新增组件
    async addResources(postData) {
        return await this.post('/api/v2/admin/wechatComponents', postData);
    }
    // 修改组件
    async editResources(id, postData) {
        return await this.put(`/api/v2/admin/wechatComponents/${id}`, postData);
    }
    // 修改组件状态
    async resourcesChangeShow(id, data) {
        return await this.patch(`/api/v2/admin/wechatComponents/status/${id}`, data);
    }
    // 修改组件权重
    async resourcesChangeSort(id, data) {
        return await this.patch(`/api/v2/admin/wechatComponents/sort/${id}`, data);
    }
}

export default new resourcesService();